import {MOKA_SERVICE_URL} from 'api/constants'

export const SYNC_BILL_SERVICE_URL = `${MOKA_SERVICE_URL}/sync-bill/v1`



// WEBPACK FOOTER //
// ./app/api/syncBill/constants.js